<template>
  <v-layout fill-height column class="page-solution-weather">
    <v-overlay v-model="loading">
      <v-progress-circular
          indeterminate
      ></v-progress-circular>
    </v-overlay>
    <div class="subheader">{{ ques[0] }}</div>
    <v-container flex-fill fluid>
      <template v-if="!loading">
        <div class="answer text-center">
          <!-- <Weather class="icon-weather"/> -->
          <img :src="getImage(weather[this.weatherNo])" class="icon-weather">
        </div>

        <section class="question-block">
          <div class="question">{{ ques[0] }}</div>
          <v-slider v-if="cmplt"
                    v-model="scoreArr[0]"
                    step="10"
                    hide-details
                    track-fill-color="transparent"
                    thumb-color="#fff"
                    readonly
                    class="unit-slider-bar"
          ></v-slider>
          <v-slider v-else
                    v-model="scoreArr[0]"
                    step="10"
                    hide-details
                    track-fill-color="transparent"
                    thumb-color="#fff"
                    class="unit-slider-bar"
          ></v-slider>
          <div class="slider-values">
            <span class="min">0</span>
            <span class="max">10</span>
          </div>
          <div class="slider-value" v-text="replyArr[0][scoreArr[0]/10]"></div>
        </section>

        <section class="question-block">
          <div class="question">{{ ques[1] }}</div>
          <v-slider v-if="cmplt"
                    v-model="scoreArr[1]"
                    step="10"
                    hide-details
                    track-fill-color="transparent"
                    thumb-color="#fff"
                    readonly
                    class="unit-slider-bar"
          ></v-slider>
          <v-slider v-else
                    v-model="scoreArr[1]"
                    step="10"
                    hide-details
                    track-fill-color="transparent"
                    thumb-color="#fff"
                    class="unit-slider-bar"
          ></v-slider>
          <div class="slider-values">
            <span class="min">0</span>
            <span class="max">10</span>
          </div>
          <div class="slider-value" v-text="replyArr[1][scoreArr[1]/10]"></div>
        </section>

        <section class="question-block">
          <div class="question">{{ ques[2] }}</div>
          <v-slider v-if="cmplt"
                    v-model="scoreArr[2]"
                    step="10"
                    hide-details
                    track-fill-color="transparent"
                    thumb-color="#fff"
                    readonly
                    class="unit-slider-bar"
          ></v-slider>
          <v-slider v-else
                    v-model="scoreArr[2]"
                    step="10"
                    hide-details
                    track-fill-color="transparent"
                    thumb-color="#fff"
                    class="unit-slider-bar"
          ></v-slider>
          <div class="slider-values">
            <span class="min">0</span>
            <span class="max">10</span>
          </div>
          <div class="slider-value" v-text="replyArr[2][scoreArr[2]/10]"></div>
        </section>

      </template>
    </v-container>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext" :unit-dtl-use-list="unitDtlUseList"/>
  </v-layout>
</template>

<script>
import store from '@/store'
// import Weather from "@/components/icons/Weather";
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  components: {
    // Weather,
    FooterBtnsNext
  },
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq", "regDt"],
  // props:{
  //   current:Number,
  //   total:Number,
  //   cmplt:Boolean
  // },
  data: () => ({
    loading: true,
    disabledNext: false,
    free: 'N',
    cmplt: false,
    ques: [],
    scoreArr: [],
    replyArr: [[], [], []],
    replyObjArr: [[], [], []],
    userReplyNo: [0, 0, 0],  // 유저답변 번호 초기값
    userReply: [],
    weather: ['weather/ic_weather01.svg', 'weather/ic_weather02.svg', 'weather/ic_weather03.svg', 'weather/ic_weather04.svg', 'weather/ic_weather05.svg'],
    weatherNo: 0,
  }),
  watch: {
    // 1번 질문 변경에 따라 날씨 이미지 변경
    scoreArr() {
      if (this.scoreArr[0] / 10 == 0 || this.scoreArr[0] / 10 == 1) {
        this.weatherNo = 4
      } else if (this.scoreArr[0] / 10 == 2 || this.scoreArr[0] / 10 == 3) {
        this.weatherNo = 3
      } else if (this.scoreArr[0] / 10 == 4 || this.scoreArr[0] / 10 == 5 || this.scoreArr[0] / 10 == 6) {
        this.weatherNo = 2
      } else if (this.scoreArr[0] / 10 == 7 || this.scoreArr[0] / 10 == 8) {
        this.weatherNo = 1
      } else if (this.scoreArr[0] / 10 == 9 || this.scoreArr[0] / 10 == 10) {
        this.weatherNo = 0
      }
    }
  },
  created() {
    this.getUnitDetailUse();
  },
  methods: {
    async getUnitDetailUse() {
      this.loading = true
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [
              {'unitUseNo': this.unitUseNo},
              {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
              {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
              {'freeYn': 'Y'},
              {'regDt': this.regDt},
              {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 스코어 기본셋팅
            this.scoreArr = ['50', '50', '50']

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl, j) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr[i][j] = replyEl.reply
                this.replyObjArr[i][j] = replyEl
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                // console.log('userReplyEl.score : ', userReplyEl.score)
                this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                this.scoreArr[i + j] = userReplyEl.score * 10
              });
            });
          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
          this.loading = false
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        this.scoreArr.forEach((score, i) => {
          // 답변 객체
          let replyObj = this.replyObjArr[i][score / 10]

          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: this.userReplyNo[i],
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: replyObj.reply,
            score: score / 10,
            freeYn: this.free
          }

        });
        this.disabledNext = true
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => {
                this.disabledNext = false
                this.$emit('next')
              }, 500); // 저장한 이후
            } else {
              this.disabledNext = false
              console.log(res.msg)
            }
          })
          .catch(error => {
            this.disabledNext = false
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
  }
}
</script>
